"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborationState = void 0;
var CollaborationState;
(function (CollaborationState) {
    CollaborationState["OK"] = "OK";
    CollaborationState["NotProvisioned"] = "NotProvisioned";
    CollaborationState["M365TenantNotMatch"] = "M365TenantNotMatch";
    CollaborationState["EmptyM365Tenant"] = "EmptyM365Tenant";
    CollaborationState["m365AccountNotSignedIn"] = "M365AccountNotSignedIn";
})(CollaborationState || (exports.CollaborationState = CollaborationState = {}));
//# sourceMappingURL=permissionInterface.js.map